module.exports = __webpack_public_path__ + "static/media/Sanjay.4ee9bf9b.jpeg";